import { createContext } from "react";

const ProjectFormGeneralContext = createContext();

export default ProjectFormGeneralContext;